import {ChangeDetectorRef, Component, OnDestroy} from "@angular/core";
import {DealEvents} from "../deal-events";
import {DealModel} from "../deal.model";
import {Subscription} from "rxjs";

@Component({
    selector: "woa-deal-summary-icon",
    templateUrl: "./deal-summary-icon.component.html"
})
export class DealSummaryIconComponent implements OnDestroy {

    private subscriptions: Subscription = new Subscription();

    constructor(public dealModel: DealModel,
                private changeDetectorRef: ChangeDetectorRef) {
        this.subscriptions.add(DealEvents.dealStatusChanged$.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/deal/deal-summary-icon/deal-summary-icon.component.ts